/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The account type (Real, Test, Demo)

Values: 0=Real, 1=Test, 2=Demo
 * @export
 * @enum {number}
 */

export enum AccountType {
    Real = 0,
    Test = 1,
    Demo = 2
}


